import React from "react";
import { useTranslation } from "react-i18next";
import { Text, TouchableOpacity, View } from "react-native";

type RadioOptionProps = {
  selected: boolean;
  onSelect: () => void;
  label: string;
  description?: string;
};

const ScRadioOption = ({
  selected,
  onSelect,
  label,
  description,
}: RadioOptionProps) => {
  const { t } = useTranslation();
  return (
    <TouchableOpacity
      onPress={onSelect}
      activeOpacity={0.7}
      className={`flex-row items-center gap-3 px-4 py-3 hover:bg-ash-3 hover:rounded-lg ${
        selected ? "bg-ash-3" : "bg-chalk"
      }`}
    >
      {/* Radio dot */}
      <View
        className={`w-4 h-4 rounded-full mt-0.5 items-center justify-center border-2 ${
          selected ? "border-primary bg-white" : "border-ash-3"
        }`}
      >
        {selected && <View className="w-2 h-2 rounded-full bg-primary" />}
      </View>

      {/* Text */}
      <View className="flex-1">
        <Text
          className={`text-sm font-semibold ${selected ? "text-primary" : "text-ash-2"}`}
        >
          {t(label)}
        </Text>
        {description && (
          <Text className="text-xs text-gray-dark mt-0.5">
            {t(description)}
          </Text>
        )}
      </View>
    </TouchableOpacity>
  );
};

export default ScRadioOption;
